import "./HomePage.css";
import NavBar from '../../components/NavBar/NavBar';
import Footer from '../../components/Footer/Footer';
import Hero from './homeComponents/Hero';
import ServicesSection from './homeComponents/ServicesSection';
import Testimonials from './homeComponents/Testimonials';
import ActivitiesSection from './homeComponents/ActivitiesSection';
import TeamSection from './homeComponents/TeamSection';
import NewsSection from './homeComponents/NewsSection';
import Faqs from '../../components/Faqs/Faqs';

const HomePage = () => {
  return (
    <div>
      <NavBar />
      <Hero />
      <ServicesSection />
      <ActivitiesSection />
      {/* <TeamSection /> */}
      <Testimonials />
      <NewsSection />
      <Faqs />
      <Footer />
    </div>
  )
}

export default HomePage